import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "layoutType", "title", "backgroundColor", "className", "cards", "titleAlign"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import cn from 'classnames';
import { Grid } from '@sbercloud/uikit-product-site-grid';
import { extractSupportProps } from '@sbercloud/uikit-product-utils';
import { CardSocial } from '../../helperComponents';
import { SectionBasic } from '../SectionBasic';
import { GRID_CONFIG } from './constants';
import styles from "./styles.module.css";
import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export function SectionSocial(_ref) {
  var id = _ref.id,
    layoutType = _ref.layoutType,
    title = _ref.title,
    backgroundColor = _ref.backgroundColor,
    className = _ref.className,
    cards = _ref.cards,
    titleAlign = _ref.titleAlign,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(SectionBasic, _objectSpread(_objectSpread({
    id: id,
    title: title,
    titleAlign: titleAlign,
    backgroundColor: backgroundColor,
    layoutType: layoutType,
    className: cn(className, styles.sectionSocial)
  }, extractSupportProps(rest)), {}, {
    children: /*#__PURE__*/_jsx(Grid, {
      columnsConfig: GRID_CONFIG,
      layoutType: layoutType,
      gap: "s",
      children: cards.map(function (card, index) {
        var _card$dataTestId;
        return /*#__PURE__*/_createElement(CardSocial, _objectSpread(_objectSpread({}, card), {}, {
          key: card.title,
          layoutType: layoutType,
          "data-test-id": (_card$dataTestId = card['data-test-id']) !== null && _card$dataTestId !== void 0 ? _card$dataTestId : "section-social__card-".concat(index)
        }));
      })
    })
  }));
}